export default __webpack_public_path__ + "static/media/upvote.4abcf6a9.svg";